import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { useLocation, useHistory } from 'react-router-dom';
import { select, withQuery } from '@panel/commons/core/themev2';
import { getColor } from '@panel/commons/core/themev3';
import {
  getDevice,
  momentFormaterISO,
  getIsTransitionOrBundleCredit,
  isPortalWithClonedPostings
} from '@panel/commons/helpers';
import DesempenoIcon from '@panel/commons/assets/icons/desempeno-icon.svg';
import DesempenoIconLight from '@panel/commons/assets/icons/desempeno-greyLight.svg';
import { SimpleButton, sendTrackingInfo } from '@panel/commons';
import EstadisticasIcon from '@panel/commons/assets/icons/estadisticas-icon.svg';
import SnackBarContainer from '@panel/commons/lib/SimpleSnackbar/SnackBarContainer';
import { useQuery } from '@panel/commons/hooks';
import { userInfoSelectors } from '@panel/core/src/state/ducks/user';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import PageHeader from '@panel/estadisticas/src/components/PageContainer/PageHeader';
import GeneralDataStatistics from '@panel/estadisticas/src/components/PageContainer/GeneralData';
import ConversionChart from '@panel/estadisticas/src/components/PageContainer/ConversionChart';
import ContactChart from '@panel/estadisticas/src/components/PageContainer/ContactChart';
import FooterInformation from '@panel/estadisticas/src/components/FooterInformation';
import { dataStatisticsAdapter } from '@panel/estadisticas/src/components/dataStatisticsAdapter';
import { dataStatisticsChartAdapter } from '@panel/estadisticas/src/components/dataStatisticsChartAdapter';
import Loader from '@panel/commons/lib/SimpleLoader';
import { Modal } from '@panel/commons/lib/Modals/ModalWrapper';
import { dateFormatted } from '@panel/estadisticas/src/helpers/datesFormatHelper';
import { bumexFeatureSelectors } from '@panel/core/src/state/ducks/bumexFeatures';
import { getLinkToEdit } from '@panel/core/src/utils/getPublisherLinks';
import { DesempenoSelectors, DesempenoOperations } from '../../ducks/desempeno';
import { performanceOperations, performanceSelectors } from '../../ducks/performance';
import PostingCardPreview from './PostingCardPreview';
import PostingNotFound from './PostingNotFound';
import Title from './Title';
import ModalsArea from './ModalsArea';
import Table from '../Table';
import BackgroundImage from '../../../assets/img/bg-desempeno.svg';
import GeneralData from './GeneralData';
import Skeleton from './Skeleton/index';
import TipCarousel from './TipCarousel';
import { FilterSelectors, FilterOperations } from '../../ducks/filtros';
import { RendimientoSelectors, RendimientoOperations } from '../../ducks/rendimiento';
import { dataTableAdapter } from '../Table/dataTableAdapter';
import ButtonPanel from './ButtonPanel';
import ButtonShareView from './ButtonShareView';

function DesempenoContainer() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const device = getDevice();
  const isDesktop = device === 'desktop';
  const [postingId, show] = useQuery(useLocation(), ['postingId', 'show']);
  const linkToLeads = `panel/interesados?&idAviso=${postingId}&from=aviso`;
  const isStatisticsByPosting = show === 'statistics';
  const [updateData, setUpdateData] = useState({ date: null, hour: null });
  const [showModal, setShowModal] = useState({
    performanceTips: false,
    reportsModal: false,
    upgrade: false,
    editIntegrator: false,
    printModal: false,
    endModal: false
  });
  const [finishedAction, setFinishedAction] = useState({
    postingId: '',
    action: '',
    result: '',
    isParticularNotFree: false
  });
  const [comparisonType, setComparisonType] = useState('average');
  const [tableData, setTableData] = useState();
  const [leadsData, setLeadsData] = useState();
  const [leadsChartData, setLeadsChartData] = useState();
  const [chartType, setChartType] = useState('impressions');
  const [showSelectPosting, setShowSelectPosting] = useState({ toBackButton: false, toTitle: false });
  const [showShareOptions, setShowShareOptions] = useState(false);
  const [dataToShare, setDataToShare] = useState({
    preview: {},
    stats: {},
    averagePosting: {},
    bestPosting: {},
    priceAveragePosting: {}
  });

  const {
    posting,
    userIsAuthorized,
    loadingAuthorization,
    postingQuality,
    loadingPostingQuality,
    loadingPostingInfo,
    postingTips,
    publishPostingError,
    publishPostingSuccess,
    saveTagError,
    saveTagSuccess,
    loadingTips,
    isDuplicate,
    isPenalized,
    isRentedOrSold,
    hasDesempenoData,
    postingInfoToShare,
    finishReason,
    loadingFinishReason,
    loadingSuspendPosting,
    fetchedSuspendPosting,
    suspendSuccessful,
    suspendError,
    showUnreadLeadsModal,
    sendUnreadLeadsMsgSuccess,
    sendUnreadLeadsMsgError
  } = useSelector(DesempenoSelectors.getDesempenoState);
  const {
    performanceStatus,
    postingStatistics,
    bestPostingStatistics,
    priceStatistics,
    loadingPerformance,
    loadingPostingStatistics,
    priceLoading,
    hasPerformanceData
  } = useSelector(performanceSelectors.getPerformanceStatistics);
  const { bumexFeatures } = useSelector(bumexFeatureSelectors.getBumexFeatureState);
  const { publisherId, publisherTypeId, isIntegrator, isAssistant } = useSelector(userInfoSelectors.getuserInfoState);

  const showTable = postingStatistics && postingStatistics.createTable;
  const {
    getPostingInfo,
    getPostingQuality,
    getAuthorization,
    getLeadsStats,
    getPostingLogs,
    getPostingTips,
    fetchReports,
    fetchCredits,
    updatePostingInfo,
    getFinishReason,
    getPostingFullInfo
  } = DesempenoOperations;
  const {
    postingLeads,
    postingLeadsCharts,
    loadingPostingLeads,
    loadingCharts,
    hasRendimientoData,
    hasRendimientoDataCharts
  } = useSelector(RendimientoSelectors.getRendimientoState);
  const { getPostingLeads, getPostingLeadsCharts } = RendimientoOperations;
  const { headerFilter, startFilter, endFilter } = useSelector(FilterSelectors.getFiltersState);
  const { appliedFilter } = FilterOperations;
  const { publicationPlanId, status, urlPosting, publicationType } = posting;
  const hasPermissions = userIsAuthorized;
  const isOnline = !['OFFLINE', 'WITHOUT_CREDIT'].includes(status);
  const isDevelopment = publicationType !== 'Clasificado';
  const userIsParticular = publisherTypeId === '1';

  const redirectToEdit = () => {
    window.open(
      `${window.location.origin}${getLinkToEdit(userIsParticular, bumexFeatures, postingId, isDevelopment)}`,
      '_blank'
    );
  };

  const performanceDisabled =
    ['DRAFT', 'OFFLINE', 'WITHOUT_CREDIT'].includes(posting.status) ||
    (isStatisticsByPosting && performanceStatus === 'NO-DATA-AVAILABLE');

  const hasSelectorPosting =
    getIsTransitionOrBundleCredit(parseInt(publicationPlanId)) &&
    ['ONLINE', 'NEAR_END'].includes(status) &&
    isPortalWithClonedPostings;

  const redirectUrlPosting = `${window.location.origin}/${t('panel.url.property')}/${urlPosting}`;
  const linkToPanel = '/panel/avisos';

  const redirectToPosting = hasMirror => {
    if (hasMirror) {
      window.open(`${redirectUrlPosting}?mirror=true`, '_blank');
      sendTrackingInfo('Panel', 'Mis avisos', 'Desempeño del aviso-Ir al aviso secundario');
    } else {
      window.open(redirectUrlPosting, '_blank');
      sendTrackingInfo('Panel', 'Mis avisos', 'Desempeño del aviso-Ir al aviso');
    }
    setShowSelectPosting({ toBackButton: false, toTitle: false });
  };
  const optionsPostingsArray = [
    { text: t('posting.card.goToPrincipalPosting'), handleOnClick: () => redirectToPosting(), id: '01' },
    { text: t('posting.card.goToClonedPosting'), handleOnClick: () => redirectToPosting(true), id: '02' }
  ];

  const showDesempeno = performanceDisabled
    ? { icon: DesempenoIconLight, wording: 'withoutDesempeno' }
    : { icon: DesempenoIcon, wording: 'toDesempeno' };

  const redirectToLeads = () => {
    sendTrackingInfo('Panel', 'Mis avisos', 'Card del aviso-Ver consultas');
    const redirectUrl = `${window.location.origin}/${linkToLeads}`;
    window.open(redirectUrl, '_blank');
  };

  const handleOutsideClick = onElement => {
    if (onElement) {
      setShowSelectPosting({ toBackButton: false, toTitle: false });
    }
  };

  const handleShareButtonOutsideClick = onElement => {
    if (onElement) {
      setShowShareOptions(false);
    }
  };

  useEffect(() => {
    setDataToShare({
      preview: postingInfoToShare,
      stats: {
        impressions: leadsData && leadsData.impressions ? leadsData.impressions.total : '-',
        views: leadsData && leadsData.visits ? leadsData.visits.total : '-',
        leads: leadsData && leadsData.leads ? leadsData.leads.total : '-'
      },
      averagePosting: postingStatistics,
      bestPosting: bestPostingStatistics,
      priceAveragePosting: priceStatistics
    });
  }, [postingInfoToShare, postingStatistics, bestPostingStatistics, priceStatistics, leadsData]);

  useEffect(() => {
    //  Efecto por acción de 'FiNALIZAR' POSTING:
    // En caso de éxito se muestra el snackbar SUCCESS:
    if (fetchedSuspendPosting && suspendSuccessful) {
      setFinishedAction({
        postingId: '',
        action: 'SUSPEND',
        result: 'SUCCESS',
        component: t('panel.desempeno.supend.snackbar.SUCCESS'),
        keepOpen: false
      });
    }
    // En caso de error se muestra el snackbar ERROR en desempeño (para todos los dispositivos):
    if (fetchedSuspendPosting && suspendError) {
      setFinishedAction({
        postingId: '',
        action: 'SUSPEND',
        result: 'ERROR',
        component: t('panel.desempeno.supend.snackbar.ERROR'),
        keepOpen: false
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [suspendSuccessful, suspendError, fetchedSuspendPosting]);

  useEffect(() => {
    // Efecto para envío de mensaje a consultas sin responder, luego de la finalización del aviso:
    if (sendUnreadLeadsMsgSuccess) {
      setFinishedAction({
        postingId: '',
        action: 'unreadLeadsMsg',
        result: 'SUCCESS',
        component: t('panel.avisos.unreadLeadsMsg.snackbar.SUCCESS')
      });
    }
    if (sendUnreadLeadsMsgError) {
      setFinishedAction({
        postingId: '',
        action: 'unreadLeadsMsg',
        result: 'ERROR',
        component: t('panel.avisos.unreadLeadsMsg.snackbar.ERROR')
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sendUnreadLeadsMsgSuccess, sendUnreadLeadsMsgError]);

  useEffect(() => {
    // Efecto para redirigir a '/panel/avisos' luego de mostrar el snackbar de Éxito de aviso finalizado:
    if (finishedAction.action === 'SUSPEND' && finishedAction.result === 'SUCCESS' && !showUnreadLeadsModal) {
      setTimeout(() => {
        window.open(linkToPanel, '_self');
      }, 3000);
    }
    if (finishedAction.action === 'unreadLeadsMsg' && finishedAction.result === 'SUCCESS') {
      setTimeout(() => {
        window.open(linkToPanel, '_self');
      }, 3000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [finishedAction, showUnreadLeadsModal]);

  // effect para snackbar de reservado
  useEffect(() => {
    if (saveTagError) {
      setFinishedAction({
        postingId: '',
        action: 'reservation',
        result: 'ERROR',
        component: t('panel.avisos.reservation.snackbar.ERROR'),
        keepOpen: false
      });
    }
    if (saveTagSuccess) {
      dispatch(updatePostingInfo(postingId));
      setFinishedAction({
        postingId: '',
        action: 'reservation',
        result: 'SUCCESS',
        component: t('panel.avisos.reservation.snackbar.SUCCESS'),
        keepOpen: false
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saveTagError, saveTagSuccess]);

  // effect para snackbar de upgrade plan
  useEffect(() => {
    if (publishPostingError) {
      setFinishedAction({
        postingId: '',
        action: 'PUBLISH',
        result: 'ERROR',
        component: t('panel.avisos.publish.snackbar.ERROR'),
        keepOpen: false
      });
    }
    if (publishPostingSuccess) {
      dispatch(updatePostingInfo(postingId));
      setFinishedAction({
        postingId: '',
        action: 'PUBLISH',
        result: 'SUCCESS',
        component: t('panel.avisos.publish.snackbar.SUCCESS'),
        keepOpen: false
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [publishPostingError, publishPostingSuccess]);

  const {
    fetchPerformanceStatus,
    getPostingStatistics,
    getBestPostingStatistics,
    getPriceStatistics
  } = performanceOperations;

  const fetchingData =
    loadingAuthorization ||
    loadingPostingQuality ||
    loadingPostingInfo ||
    loadingPerformance ||
    loadingPostingStatistics ||
    priceLoading ||
    loadingTips ||
    loadingPostingLeads ||
    loadingCharts ||
    (isOnline && !tableData && postingStatistics && bestPostingStatistics);

  useEffect(() => {
    if (publisherTypeId) {
      dispatch(getFinishReason(publisherTypeId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [publisherTypeId]);

  useEffect(() => {
    dispatch(getPostingFullInfo(postingId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postingId]);

  useEffect(() => {
    dispatch(getAuthorization(postingId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postingId]);

  useEffect(() => {
    // se buscan los datos para card preview
    if (!hasDesempenoData && !loadingAuthorization && !loadingPostingQuality && !loadingPostingInfo) {
      dispatch(getPostingInfo(postingId));
      dispatch(getPostingQuality(postingId));
    }
    // se buscan los datos para desempeno
    if (userIsAuthorized && !hasPerformanceData && !isStatisticsByPosting) {
      dispatch(fetchPerformanceStatus(postingId));
      dispatch(getLeadsStats(postingId));
      dispatch(getPostingLogs(postingId));
      dispatch(getPostingStatistics(postingId));
      dispatch(getBestPostingStatistics(postingId));
      dispatch(getPriceStatistics(postingId));
      dispatch(getPostingTips(postingId));
      dispatch(fetchReports(postingId));
      dispatch(fetchCredits());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userIsAuthorized, isStatisticsByPosting]);

  useEffect(() => {
    setTableData(dataTableAdapter({ postingStatistics, bestPostingStatistics, priceStatistics }, comparisonType));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postingStatistics, bestPostingStatistics, priceStatistics, comparisonType]);

  const date = new Date();
  const selectFilterList = {
    firstPeriod: 7,
    secondPeriod: 30,
    thirdPeriod: 90,
    customPeriod: 0
  };

  const updateFilter = (option, startPeriod, endPeriod) => {
    dispatch(appliedFilter({ filter: option, filterStartPeriod: startPeriod, filterEndPeriod: endPeriod }));
  };

  useEffect(() => {
    if (postingLeads) {
      setLeadsData(dataStatisticsAdapter(postingLeads));
    }
    if (postingLeadsCharts) {
      setLeadsChartData(dataStatisticsChartAdapter(postingLeadsCharts));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postingLeads, postingLeadsCharts]);

  useEffect(() => {
    // se buscan los datos para estadisticas por aviso
    if (headerFilter === 'customPeriod') {
      dispatch(
        getPostingLeads(postingId, selectFilterList[headerFilter], dateFormatted(startFilter), dateFormatted(endFilter))
      );
      dispatch(
        getPostingLeadsCharts(
          postingId,
          selectFilterList[headerFilter],
          dateFormatted(startFilter),
          dateFormatted(endFilter)
        )
      );
    } else {
      dispatch(getPostingLeads(postingId, selectFilterList[headerFilter]));
      dispatch(getPostingLeadsCharts(postingId, selectFilterList[headerFilter]));
    }
    // Se busca el PerformanceStatus para saber si se debe habilitar o no el botón para ir a desempeño
    dispatch(fetchPerformanceStatus(postingId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [headerFilter, startFilter, endFilter]);

  useEffect(() => {
    if (hasRendimientoData || hasRendimientoDataCharts) {
      setUpdateData({
        ...updateData,
        date: momentFormaterISO(date, 'DD/MM/YYYY'),
        hour: momentFormaterISO(date, 'HH:mm')
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasRendimientoData, hasRendimientoDataCharts]);

  const onChangeViewPress = () => {
    const params = new URLSearchParams(window.location.search);
    if (isStatisticsByPosting) {
      params.delete('show');
    } else {
      params.append('show', 'statistics');
    }
    history.replace({ search: params.toString() });
    sendTrackingInfo(
      'Panel',
      `${isStatisticsByPosting ? 'Estadisticas' : 'Mis avisos'}`,
      `${isStatisticsByPosting ? 'Rendimiento-Ver Desempeño' : 'Desempeño del aviso-Ver Estadisticas'}`
    );
    setShowShareOptions(false);
  };

  return (
    <Container device={device}>
      <SnackBarContainer action={finishedAction} deviceType={device !== 'mobile' ? 'desktop' : 'mobile'} />
      {loadingSuspendPosting && (
        <Modal backgroundColor='transparent'>
          <LoaderWrapper>
            <Loader />
          </LoaderWrapper>
        </Modal>
      )}
      <ModalsArea
        device={device}
        posting={posting}
        showModal={showModal}
        setShowModal={setShowModal}
        postingQuality={postingQuality}
        redirectToEdit={redirectToEdit}
        postingId={postingId}
        isReserved={posting.isReserved}
        isIntegrator={isIntegrator}
        publisherTypeId={publisherTypeId}
        setFinishedAction={setFinishedAction}
        isAssistant={isAssistant}
        finishReason={finishReason}
        loadingFinishReason={loadingFinishReason}
        publisherId={publisherId}
      />
      <UpperContainer device={device} isStatisticsByPosting={isStatisticsByPosting}>
        {!loadingAuthorization && !hasPermissions && <PostingNotFound linkToPanel={linkToPanel} device={device} />}
        {fetchingData && <Skeleton device={device} isStatisticsByPosting={isStatisticsByPosting} />}
        {device !== 'desktop' && !fetchingData && hasPermissions && (
          <FloatButton>
            <SimpleButton
              color={select(!performanceDisabled ? 'black' : 'midLightGray')}
              borderColor={!performanceDisabled ? getColor('primary') : select('midLightGray')}
              backgroundColor={select(!performanceDisabled ? 'white' : 'lightGray')}
              cursorDisabled={performanceDisabled}
              onClick={!performanceDisabled ? onChangeViewPress : null}
              height='40px'
              borderRadius='8px'
              backgroundColorHover={getColor('tertiary')}
            >
              <img src={isStatisticsByPosting ? showDesempeno.icon : EstadisticasIcon} alt='Ir a estadisticas' />
              {t(`panel.estadisticas.posting.${isStatisticsByPosting ? showDesempeno.wording : 'toStatistics'}.CTA`)}
            </SimpleButton>
          </FloatButton>
        )}
        {hasPermissions && !fetchingData && (
          <ContentLayout device={device}>
            {device !== 'desktop' && !isStatisticsByPosting ? (
              <Title posting={posting} device={device} />
            ) : (
              device !== 'desktop' &&
              isStatisticsByPosting && (
                <PageHeader
                  headerFilter={headerFilter}
                  startFilter={startFilter}
                  endFilter={endFilter}
                  selectFilterList={selectFilterList}
                  updateFilter={updateFilter}
                  isDesktop={isDesktop}
                  device={device}
                  title={t('panel.desempeno.estadisticas.title')}
                  insideHeader
                  likeDesktop
                  withTooltip={device === 'mobile'}
                  isStatisticsByPosting
                  updateData={updateData}
                />
              )
            )}
            <CardArea className={`desempeno-card-area-${device}`} device={device}>
              <ButtonPanel
                isAssistant={isAssistant}
                userIsAuthorized={hasPermissions}
                fetchingData={fetchingData}
                isIntegrator={isIntegrator}
                setShowModal={setShowModal}
                publisherTypeId={publisherTypeId}
                posting={posting}
                postingId={postingId}
                isStatisticsByPosting={isStatisticsByPosting}
                onChangeViewPress={onChangeViewPress}
                performanceDisabled={performanceDisabled}
                showSelectPosting={showSelectPosting}
                setShowSelectPosting={setShowSelectPosting}
                hasSelectorPosting={hasSelectorPosting}
                optionsPostingsArray={optionsPostingsArray}
                handleOutsideClick={handleOutsideClick}
                publisherId={publisherId}
                setFinishedAction={setFinishedAction}
                handleShareButtonOutsideClick={handleShareButtonOutsideClick}
                showShareOptions={showShareOptions}
                setShowShareOptions={setShowShareOptions}
                dataToShare={dataToShare}
              />
              <PostingCardPreview
                showModal={showModal}
                setShowModal={setShowModal}
                postingId={postingId}
                posting={posting}
                device={device}
                postingQuality={postingQuality}
                isIntegrator={isIntegrator}
                isDuplicate={isDuplicate}
                isPenalized={isPenalized}
                isAssistant={isAssistant}
                isStatisticsByPosting={isStatisticsByPosting}
                showSelectPosting={showSelectPosting}
                setShowSelectPosting={setShowSelectPosting}
                hasSelectorPosting={hasSelectorPosting}
                optionsPostingsArray={optionsPostingsArray}
                handleOutsideClick={handleOutsideClick}
              />
            </CardArea>
            {!isStatisticsByPosting ? (
              <RightContainer device={device}>
                {device === 'desktop' && (
                  <HeaderTitle>
                    <Title posting={posting} device='desktop' />
                    <ButtonShareView
                      postingId={postingId}
                      publisherId={publisherId}
                      dataToShare={dataToShare}
                      setShowShareOptions={setShowShareOptions}
                      showShareOptions={showShareOptions}
                      handleShareButtonOutsideClick={handleShareButtonOutsideClick}
                      setFinishedAction={setFinishedAction}
                    />
                    <SimpleButton
                      color='black'
                      borderColor={getColor('primary')}
                      id='test-btn-2'
                      onClick={onChangeViewPress}
                      height='40px'
                      borderRadius='8px'
                      backgroundColorHover={getColor('tertiary')}
                    >
                      <img src={EstadisticasIcon} alt='Ir a estadisticas' />
                      {t('panel.estadisticas.posting.toStatistics.CTA')}
                    </SimpleButton>
                  </HeaderTitle>
                )}
                <GeneralData
                  performanceStatus={performanceStatus}
                  device={device}
                  leads={leadsData && leadsData.leads ? leadsData.leads.total : '-'}
                  impressions={leadsData && leadsData.impressions ? leadsData.impressions.total : '-'}
                  visits={leadsData && leadsData.visits ? leadsData.visits.total : '-'}
                  handleRedirectLeads={redirectToLeads}
                />
                {postingTips && postingTips.length ? (
                  <TipCarousel
                    tips={postingTips}
                    redirectToEdit={redirectToEdit}
                    device={device}
                    setShowModal={setShowModal}
                    postingQuality={postingQuality}
                    isParticular={publisherTypeId === '1'}
                    postingId={postingId}
                    isIntegrator={isIntegrator}
                    publicationPlan={posting.publication_plan}
                    isDuplicate={isDuplicate}
                    isPenalized={isPenalized}
                    isRentedOrSold={isRentedOrSold}
                    isAssistant={isAssistant}
                  />
                ) : null}
                {isOnline && showTable && (
                  <Table
                    tableData={tableData}
                    comparisonType={comparisonType}
                    setComparisonType={setComparisonType}
                    posting={posting}
                    postingId={postingId}
                    hasBestData={bestPostingStatistics}
                  />
                )}
              </RightContainer>
            ) : (
              <StatisticsContainer device={device}>
                {isDesktop && (
                  <PageHeader
                    headerFilter={headerFilter}
                    startFilter={startFilter}
                    endFilter={endFilter}
                    selectFilterList={selectFilterList}
                    updateFilter={updateFilter}
                    isDesktop={isDesktop}
                    title={t('panel.desempeno.estadisticas.title')}
                    insideHeader
                    onChangeViewPress={onChangeViewPress}
                    performanceDisabled={performanceDisabled}
                    device={device}
                    updateData={updateData}
                    isStatisticsByPosting
                  />
                )}
                <GeneralDataStatistics
                  data={leadsData || ''}
                  dataCharts={leadsChartData}
                  chartType={chartType}
                  setChartType={setChartType}
                  device={device}
                  filter={headerFilter}
                  startFilter={startFilter}
                  endFilter={endFilter}
                  isStatisticsByPosting={isStatisticsByPosting}
                  postingId={postingId}
                />
                <ChartsBelowSection device={device}>
                  <ConversionChart
                    device={device}
                    data={leadsData || ''}
                    isStatisticsByPosting={isStatisticsByPosting}
                  />
                  <ContactChart device={device} data={leadsData || ''} isStatisticsByPosting={isStatisticsByPosting} />
                </ChartsBelowSection>
                {!isDesktop && <FooterInformation />}
              </StatisticsContainer>
            )}
          </ContentLayout>
        )}
      </UpperContainer>
    </Container>
  );
}

const Container = styled.div`
  background-image: ${({ device }) => device === 'desktop' && `url(${BackgroundImage})`};
  background-repeat: no-repeat;
  background-position: 0px 130px;
`;

const UpperContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1480px;
  padding: 30px 0 0 10px;
  margin: auto;
  white-space: normal;
  ${({ isStatisticsByPosting, device }) =>
    // eslint-disable-next-line no-nested-ternary
    isStatisticsByPosting && device === 'desktop'
      ? css`
          margin-bottom: 60px;
        `
      : isStatisticsByPosting && device !== 'desktop'
      ? css`
          margin-bottom: 0;
        `
      : css`
          margin-bottom: 20px;
        `}
  ${withQuery.xl.down()} {
    max-width: 1280px;
  }
  @media screen and (max-width: 1279px) {
    margin-top: 90px;
    padding: 0 16px;
  }
`;

const RightContainer = styled.div`
  width: ${({ device }) => (device !== 'desktop' ? 100 : 77.5)}%;
  @media screen and (max-width: 1480px) {
    width: ${({ device }) => (device !== 'desktop' ? 100 : 74)}%;
  }
  @media screen and (max-width: 1280px) {
    ${({ device }) =>
      device === 'desktop' &&
      css`
        margin-top: 10px;
        width: 72%;
      `}
  }
  @media screen and (max-width: 1080px) {
    width: ${({ device }) => (device !== 'desktop' ? 100 : 67)}%;
  }
`;

const ContentLayout = styled.div`
  display: flex;
  height: 100%;
  ${({ device }) =>
    device !== 'desktop' &&
    css`
      flex-direction: column;
    `};
`;

const CardArea = styled.div`
  &.desempeno-card-area-desktop {
    min-height: 100%;
    padding-right: 40px;
  }
  &.desempeno-card-area-tablet,
  &.desempeno-card-area-mobile {
    width: 100%;
  }
  ${({ device }) =>
    device !== 'desktop'
      ? css`
          border-bottom: 1px solid ${select('middleGray')};
        `
      : css`
          top: 40px;
          position: sticky;
          height: fit-content;
          @media screen and (max-width: 1280px) {
            top: 100px;
          }
        `};
`;

const HeaderTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 28px;
`;

const StatisticsContainer = styled.div`
  width: ${({ device }) => (device !== 'desktop' ? 100 : 80)}%;
  margin-bottom: ${({ device }) => (device !== 'desktop' ? 0 : 64)}px;
  @media screen and (max-width: 1530px) {
    margin-right: ${({ device }) => (device !== 'desktop' ? 0 : 16)}px;
  }
  ${withQuery.xl.down()} {
    width: ${({ device }) => (device !== 'desktop' ? 100 : 75)}%;
  }
  @media screen and (max-width: 1330px) {
    padding-right: ${({ device }) => (device !== 'desktop' ? 0 : 16)}px;
  }
  @media screen and (max-width: 1280px) {
    ${({ device }) =>
      device === 'desktop' &&
      css`
        margin-top: 10px;
      `}
  }
  @media screen and (max-width: 1480px) {
    width: ${({ device }) => (device !== 'desktop' ? 100 : 74)}%;
  }
  @media screen and (max-width: 1080px) {
    width: ${({ device }) => (device !== 'desktop' ? 100 : 67)}%;
  }
`;

const ChartsBelowSection = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${({ device }) => (device === 'tablet' ? 24 : 40)}px;
  ${({ device }) =>
    device === 'mobile' &&
    css`
      flex-direction: column;
      gap: 0;
    `}
  ${({ isDesktop }) =>
    isDesktop &&
    css`
      ${withQuery.xl.down()} {
        gap: 20px;
      }
    `}
`;

const FloatButton = styled.div`
  position: fixed;
  bottom: 20px;
  z-index: 1;
  right: 20px;
`;

const LoaderWrapper = styled.div`
  background-color: rgb(256, 256, 256, 0.6);
  width: 100vw;
  height: 100vh;
  z-index: 200;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default DesempenoContainer;
